import countryRegionData from "country-region-data";
import { CountryCode, CountryNames, OrganizationCountry } from "../types/countryRegion";
export const getOrganizationCountryFromCountryRegionData = (value) => {
    if (value === CountryNames.UnitedStates) {
        return OrganizationCountry.UnitedStates;
    }
    if (value === CountryNames.Canada) {
        return OrganizationCountry.Canada;
    }
    if (value === CountryNames.UnitedKingdom) {
        return OrganizationCountry.GreatBritain;
    }
    return OrganizationCountry.Canada;
};
export const mapOrganizationCountryToCountryNames = (organizationCountry) => {
    if (organizationCountry === OrganizationCountry.UnitedStates) {
        return CountryNames.UnitedStates;
    }
    if (organizationCountry === OrganizationCountry.Canada) {
        return CountryNames.Canada;
    }
    if (organizationCountry === OrganizationCountry.GreatBritain) {
        return CountryNames.UnitedKingdom;
    }
    return CountryNames.Canada;
};
export const mapCountryCodeToOrganizationCountry = (code) => {
    if (code === "US") {
        return OrganizationCountry.UnitedStates;
    }
    if (code === "CA") {
        return OrganizationCountry.Canada;
    }
    if (code === "GB") {
        return OrganizationCountry.GreatBritain;
    }
    return OrganizationCountry.Canada;
};
export const getOrganizationCountryFromCountryCode = (value) => {
    if (value === CountryCode.US) {
        return OrganizationCountry.UnitedStates;
    }
    if (value === CountryCode.CA) {
        return OrganizationCountry.Canada;
    }
    if (value === CountryCode.GB) {
        return OrganizationCountry.GreatBritain;
    }
    return OrganizationCountry.Canada;
};
export const getCountryRegionDataFromOrganizationCountry = (value) => {
    if (value === OrganizationCountry.UnitedStates || value === CountryCode.US) {
        return CountryNames.UnitedStates;
    }
    if (value === OrganizationCountry.Canada || value === CountryCode.CA) {
        return CountryNames.Canada;
    }
    if (value === OrganizationCountry.GreatBritain || value === CountryCode.GB) {
        return CountryNames.UnitedKingdom;
    }
    return CountryNames.Canada;
};
export const getCountryNamesFromString = (value) => {
    if (value === CountryNames.UnitedStates || value === OrganizationCountry.UnitedStates) {
        return CountryNames.UnitedStates;
    }
    if (value === CountryNames.Canada || value === OrganizationCountry.Canada) {
        return CountryNames.Canada;
    }
    if (value === CountryNames.UnitedKingdom || value === OrganizationCountry.GreatBritain) {
        return CountryNames.UnitedKingdom;
    }
    return CountryNames.Canada;
};
export const getCountry = (countryName) => {
    return countryRegionData.find((elem) => {
        return elem.countryName === countryName;
    });
};
export const getRegion = (countryName, regionName) => {
    const country = getCountry(countryName);
    return country?.regions.find((region) => region.name === regionName);
};
export const getCountryShortCodeFromOrganizationCountry = (organizationCountry) => {
    const country = getCountry(getCountryRegionDataFromOrganizationCountry(organizationCountry));
    return country?.countryShortCode;
};
export const getCountryShortCodeFromCountryName = (countryName) => {
    const country = getCountry(countryName);
    return country?.countryShortCode;
};
export const getRegionShortCodeFromCountryAndRegionName = (countryName, regionName) => {
    const region = getRegion(countryName, regionName);
    return region?.shortCode;
};
export const getRegionFromCountryAndRegionShortCode = (organizationCountry, shortCode) => {
    const country = getCountry(getCountryRegionDataFromOrganizationCountry(organizationCountry));
    return country?.regions.find((region) => region.shortCode === shortCode)?.name;
};
export const formatWithAccentCanadianRegion = (region) => {
    return region?.toLowerCase() === "quebec" ? "Québec" : region;
};
export const convertCountryToCountryCode = (country) => {
    if (country === CountryNames.UnitedStates ||
        country === OrganizationCountry.UnitedStates ||
        country === CountryNames.Canada ||
        country === OrganizationCountry.Canada ||
        country === CountryNames.UnitedKingdom ||
        country === OrganizationCountry.GreatBritain) {
        return CountryCode[getCountry(getCountryNamesFromString(country))?.countryShortCode];
    }
    return CountryCode[getCountry(country)?.countryShortCode];
};
export const convertCountryCodeToCountry = (countryCode) => {
    const foundCountryRegion = countryRegionData.find((countryRegionItem) => countryRegionItem.countryShortCode === countryCode);
    return foundCountryRegion?.countryName;
};
export const isQuebecOrganization = (region) => {
    return ["Québec", "Quebec", "QC"].includes(region ?? "");
};
